import React, { SyntheticEvent, useState } from "react";
import {
  Table,
  ScrollArea,
  Grid,
  Button,
  Divider,
  ActionIcon,
} from "@mantine/core";
import { Edit, Archive } from "tabler-icons-react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { deleteUniversity, getUniversityDetails } from "./queries";
import { Form } from "./form";

const UniversityView = () => {
  const [isOpenForm, setOpenForm] = useState(false);
  const [data, setData] = useState<UniversityProps | null>(null);
  const queryClient = useQueryClient();
  const { mutate: mutDeleteUniversity } = useMutation(deleteUniversity, {
    onSuccess: (newData) => {
      queryClient.invalidateQueries();
    },
  });

  const { isLoading, data: streamData = [] } = useQuery(
    "universities",
    getUniversityDetails,
    {
      staleTime: 60000,
      refetchOnWindowFocus: false,
    }
  );

  const onUpdateData = (payload: UniversityProps) => {
    setData(payload);
    setOpenForm(true);
  };

  const onRestForm = () => {
    setOpenForm(false);
    setData(null);
  };

  const rows =
    streamData &&
    streamData.map((row: UniversityProps) => {
      return (
        <tr key={row.id}>
          <td>{row.id}</td>
          <td>{row.name}</td>
          <td>{row.code}</td>
          <td>{row.available_on_registration ? "Yes" : "No"}</td>
          <td>{row.available_on_filter ? "Yes" : "No"}</td>
          <td>{row.isactive ? "Yes" : "No"}</td>
          <td>
            <Grid columns={2}>
              <Grid.Col span={1}>
                <ActionIcon
                  title="Update"
                  onClick={() => onUpdateData({ ...row })}
                >
                  <Edit size={25} strokeWidth={2} color={"green"} />
                </ActionIcon>
              </Grid.Col>
              <Grid.Col span={1}>
                <ActionIcon
                  title="Delete"
                  onClick={() => mutDeleteUniversity({ id: Number(row.id) })}
                >
                  <Archive size={25} strokeWidth={2} color={"red"} />
                </ActionIcon>
              </Grid.Col>
            </Grid>
          </td>
        </tr>
      );
    });

  if (isLoading) {
    // TODO loader on data loading
    return null;
  }
  return (
    <>
      <Grid justify={"flex-end"}>
        <Grid.Col lg={1}>
          <Button
            variant="light"
            onClick={(e: SyntheticEvent) => setOpenForm(true)}
          >
            Create
          </Button>
        </Grid.Col>

        <Grid.Col>
          <Divider />
          <ScrollArea
            offsetScrollbars
            style={{ height: 700, padding: 15 }}
            scrollHideDelay={1000}
          >
            <Table
              sx={{ minWidth: 800 }}
              verticalSpacing="xs"
              horizontalSpacing={"xl"}
            >
              <thead>
                <tr>
                  <th>Id</th>
                  <th>University Name</th>
                  <th>University Code</th>
                  <th>Available On Registration</th>
                  <th>Available On Filter</th>
                  <th>Is Active</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>{rows}</tbody>
            </Table>
          </ScrollArea>
        </Grid.Col>
      </Grid>
      {isOpenForm && <Form
        isOpenModal={isOpenForm}
        setOpenForm={setOpenForm}
        onReset={onRestForm}
        data={data}
      />}
    </>
  );
};

export default UniversityView;
